import React from 'react';
import Dialog from './Dialog';
import useDialogMutation from '../hooks/useDialogMutation';

function ConfirmDeleteDialog({ section, quickLaunchIds = [], onConfirm, onClose }) {
  const { run, saving, error } = useDialogMutation();
  const quickIds = new Set(quickLaunchIds);
  const kept = section.apps.filter((app) => quickIds.has(app.id)).length;
  const removed = section.apps.length - kept;
  let detail;
  if (!section.apps.length) {
    detail = 'This section has no applications.';
  } else if (kept && removed) {
    detail = `${removed} application${removed === 1 ? '' : 's'} will be removed from this section. ${kept} will remain in Quick Launch.`;
  } else if (kept) {
    detail = `Its ${kept} application${kept === 1 ? '' : 's'} will remain in Quick Launch.`;
  } else {
    detail = `This will also remove its ${removed} application${removed === 1 ? '' : 's'}.`;
  }

  return (
    <Dialog title={`Delete "${section.title}"?`} onClose={onClose} locked={saving}>
      <p className="dialog-text">{detail} This can't be undone.</p>
      {error && <p className="dialog-error" role="alert">{error}</p>}
      <div className="dialog-actions">
        <button type="button" className="btn" onClick={onClose} autoFocus disabled={saving}>Cancel</button>
        <button
          type="button"
          className="btn btn-danger"
          disabled={saving}
          onClick={() => run(() => onConfirm(section.id), onClose)}
        >
          {saving ? 'Deleting…' : 'Delete'}
        </button>
      </div>
    </Dialog>
  );
}

export default ConfirmDeleteDialog;